import { assert } from '@sindresorhus/is';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { FeedbackDialogContext } from './FeedbackDialogContext';
import type { FeedbackDialogStoreWithComputedState } from './feedback-dialog-store';

export const useFeedbackDialogStore = <T>(selector: (state: FeedbackDialogStoreWithComputedState) => T): T => {
    const feedbackDialogContext = useContext(FeedbackDialogContext);

    assert.plainObject(feedbackDialogContext);

    return useStore(feedbackDialogContext, selector);
};
